import React from 'react';

import PromoModal from 'components/shared/PromoModal';
import { translate } from 'javascripts/translations/i18n';
import { useModal } from 'components/shared/hooks';

const ShowcaseWidgetPromoModal = () => {
  const { hideModal } = useModal();
  return (
    <PromoModal
      onRequestClose={hideModal}
      titleText={translate('showcases.promoModal.title')}
      features={[
        translate('showcases.promoModal.valueProp1'),
        translate('showcases.promoModal.valueProp2'),
        translate('showcases.promoModal.valueProp3'),
      ]}
      dataTestId="showcase_widget"
      trackingAction="showcase_widget_promo_modal_opened"
    />
  );
};

export default ShowcaseWidgetPromoModal;
